import { render, staticRenderFns } from "./item.vue?vue&type=template&id=155db145&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155db145",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155db145')) {
      api.createRecord('155db145', component.options)
    } else {
      api.reload('155db145', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=155db145&scoped=true", function () {
      api.rerender('155db145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TreeMenu/item.vue"
export default component.exports